import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });

export async function startCheckout() {
  const { data } = await api.post("/payments/checkout", {
    lookup_key: "prima_ora_liberta",
    origin_url: window.location.origin,
  });
  window.location.href = data.checkout_url;
}

export function scrollToId(id) {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
}
